import Home from './Home'
import './Home.css'
import './background.css'

export default Home



// WEBPACK FOOTER //
// ./src/features/Home/containers/Home/index.js